import API from '@/services/api'

// Actions
export const INSIGHT_LOGIN = 'insightLogin'
export const INSIGHT_FETCH_PROPERTY = 'insightFetchProperty'

// Mutations
//export const STORE_SET_COMPANIES = 'storeSetCompanies'
//export const STORE_ADD_COMPANY = 'storeAddCompany'
//export const STORE_UPDATE_COMPANY = 'storeUpdateCompany'
//export const STORE_DELETE_COMPANY = 'storeDeleteCompany'

const state = {
	property: {},
}

const getters = {
	property (state) {
		return state.property
	},
}

const actions = {
	[INSIGHT_LOGIN] (context, data) {
		return new Promise((resolve, reject) => {
			API.post('insight/authenticate', data).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response.data)
			})
		})
	},
	[INSIGHT_FETCH_PROPERTY] () {
		return new Promise((resolve, reject) => {
			API.query('companies').then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
//	[STORE_SET_COMPANIES] (state, companies) {
//		state.companies = companies
//	},
//	[STORE_ADD_COMPANY] (state, company) {
//		state.companies.data.push(company)
//	},
//	[STORE_UPDATE_COMPANY] (state, company) {
//		let companies = []
//
//		state.companies.data.map((mapCompany) => {
//			if (mapCompany.id === company.id) {
//				mapCompany = company
//			}
//
//			companies.push(mapCompany)
//		})
//
//		state.companies.data = companies
//	},
//	[STORE_DELETE_COMPANY] (state, company) {
//		state.companies.data.splice(state.companies.data.indexOf(company), 1)
//	},
}

export default { state, getters, actions, mutations }